<script lang="ts" setup>
import CategoryItem from '@/pages/services/components/CategoryItem.vue'
import Process from '@/pages/services/components/Process.vue'
import Faq from '@/pages/services/components/Faq.vue'
import Review from '@/pages/services/components/Review.vue'
import Other from '@/pages/services/components/Other.vue'
import useSeo from './seo';
const lists = ref([
  {
    image: './images/services/inhome.jpg',
    title: '預約到府教學服務',
    link: '/services/inhome/form',
    rotate: 0
  },
])

const processData = ref([
  {
    pic: '',
    title: '登入恆隆行會員',
    text: ''
  },
  {
    pic: './images/services/inhome/step2.jpg',
    title: '填寫預約申請資料',
    text: '包含服務地址、理想時段、品牌、品項等資訊'
  },
  {
    pic: './images/services/inhome/step3.jpg',
    title: '到府專員致電說明',
    text: '確認服務日期及時間'
  },
  {
    pic: './images/services/inhome/step4.jpg',
    title: '到府一對一教學',
    text: ''
  },
])

const reviewLists = ref([
  {
    author: '李先生',
    text: '服務人員解說條理分明，並提供許多細節保養的小技巧，連空氣清淨淨機也一併解說，對於恆隆未來的商品，更有興趣及信心了。給予五顆評價'
  },
  {
    author: '龔小姐',
    text: '專員十分專業，我人不在家，她以清楚影音檔案，留下維修過程，讓我知道問題出在哪兒，態度也親切，服務水準極佳。無可挑剔'
  },
  {
    author: '陳小姐',
    text: '這一次的服務人員非常專業，解釋的非常清楚，我們家已經有3個Dyson吸塵器，服務員告知一些非常重要的保養技巧，讓我使用上更方便,更安心，非常謝謝。'
  }
])

const faqList = ref([
  {
    title: '到府服務是否需要費用?',
    text: '免費'
  },
  {
    title: '哪些產品可申請到府服務?',
    text: 'Dyson：吸塵器、風扇及空氣清淨機、吹風機、多功能造型器、燈具、LAURASTAR：全品項、VERMICULAR：IH 琺瑯鑄鐵電子鍋、Magimix：全品項'
  },
  {
    title: '到府服務可預約時段有哪些？',
    text: '早上9:00～下午6:00'
  },
  {
    title: '到府服務時長多久？',
    text: '60分鐘內'
  },
  {
    title: '是否可在單次到府服務中，預約多品項教學？',
    text: '一筆到府教學只能選擇一個品項，若同時需要其他恆隆行產品教學，可在和到府專員接洽時告知。 '
  },
  {
    title: '我是恆隆行會員，但指定品項為平行輸入品，適用到府服務嗎？',
    text: '到府服務僅適用於「恆隆行官方通路」販售之產品。'
  },
])

const isShow = ref(false)
const processRef = ref(null)
onMounted(() => {
  isShow.value = true
  useImagesLoaded('.service-inner img').then(() => {
    processRef.value?.initAni()
  })
})

useSeo()
</script>

<template>
  <section class="service-inner">
    <div class="service-inner__side">
      <Intro subtitle="in-home" :data="{
        title: '到府教學服務',
        text: '我們將帶給您更美好的使用經驗，針對全新商品提供專員到府服務。產品專家將在您預約的時間免費至您府上進行教學到訪，依照您購買的機型與使用情境，與您解說商品組裝、使用與保養清潔，豐富您的使用歷程，為您生活帶來的更大的便利。'
      }" class="service-inner__intro align-left display158" />
      <div class="service-inner__side__lists">
        <ul class="lists">
          <li v-for="(item, index) in lists" :key="index">
            <CategoryItem :data="{ ...item }" />
          </li>
        </ul>
      </div>
    </div>
    <div class="service-inner__rightPic square__pic h__pic" :class="{ isShow: isShow }">
      <Nimg src="./images/services/inhome/main.jpg" />
    </div>
    <Process class="service-inner__process full" enTitle="process" twTitle="申請流程" :data="processData"
      ref="processRef" />
    <Faq class="service-inner__faq full" :items="faqList" />
    <Review class="service-inner__review full" :data="reviewLists" />
    <Other class="service-inner__other full" />
  </section>
</template>

<style lang="scss" scoped>
.service-inner {
  &__intro {
    margin-right: toRem(-100);

    :deep(.intro__text) {
      font-size: toRem(16);
      line-height: 1.45;
    }
  }
}
</style>
